/* eslint-disable react/prop-types */
import React, { memo, useState } from "react";
import { FilterList } from "@material-ui/icons";
import { IconButton, Popper, Fade, Radio, RadioGroup, FormControlLabel } from "@material-ui/core";
import styles from "./style.module.scss";

const VISIBILITY_OPTIONS = [
  { value: "all", label: "All" },
  { value: "web", label: "Web" },
  { value: "system", label: "System" },
];

const FilterPopup = ({ visibility, onApply }) => {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [tempVisibility, setTempVisibility] = useState(visibility);

  const handleClickFilter = (e) => {
    setAnchorEl(e.currentTarget);
    setOpen((prev) => !prev);
    setTempVisibility(visibility);
  };

  const handleApply = () => {
    onApply(tempVisibility === "all" ? undefined : tempVisibility);
    setAnchorEl(null);
    setOpen(false);
  };

  const handleClosePopup = () => {
    setAnchorEl(null);
    setOpen(false);
  };

  const canBeOpen = open && Boolean(anchorEl);

  return (
    <>
      <IconButton onClick={handleClickFilter}>
        <FilterList />
      </IconButton>

      <Popper
        id={canBeOpen ? "visibility-filter-popper" : undefined}
        open={open}
        anchorEl={anchorEl}
        transition
        placement="bottom-start"
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <div className={styles.filterBg}>
              <div className={styles.header}>
                <span className={styles.headLine}>Filter Visibility</span>
                <span style={{ cursor: "pointer" }} onClick={handleClosePopup}>
                  x
                </span>
              </div>
              <div className={styles.filterContent}>
                <RadioGroup
                  value={tempVisibility}
                  onChange={(e) => setTempVisibility(e.target.value)}
                >
                  {VISIBILITY_OPTIONS.map((option) => (
                    <FormControlLabel
                      key={option.value}
                      value={option.value}
                      control={<Radio size="small" />}
                      label={option.label}
                    />
                  ))}
                </RadioGroup>
              </div>
              <div className={styles.footer}>
                <button
                  type="button"
                  onClick={handleClosePopup}
                  className={styles.cancelBtn}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={handleApply}
                  className={styles.applyBtn}
                >
                  Apply
                </button>
              </div>
            </div>
          </Fade>
        )}
      </Popper>
    </>
  );
};

export default memo(FilterPopup);
